import { render, staticRenderFns } from "./SilentLogin.vue?vue&type=template&id=056ba7e5&scoped=true"
import script from "./SilentLogin.vue?vue&type=script&lang=js"
export * from "./SilentLogin.vue?vue&type=script&lang=js"
import style0 from "./SilentLogin.vue?vue&type=style&index=0&id=056ba7e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056ba7e5",
  null
  
)

export default component.exports